export default {
  CUSTOMERS__UPDATE_LOADING(state, value) {
    state.loading = value;
  },
  CUSTOMERS__UPDATE_LIST_LOADING(state, value) {
    state.listLoading = value;
  },
  CUSTOMERS__UPDATE_LIST(state, value) {
    state.items = value;
  },
  CUSTOMERS__UPDATE_TOTAL(state, value) {
    state.total = value;
  },
  CUSTOMERS__UPDATE_PAGE_NO(state, value) {
    state.pageNo = value;
  },
  CUSTOMERS__UPDATE_PAGE_SIZE(state, value) {
    state.pageSize = value;
  },
  CUSTOMERS__UPDATE_ITEM(state, value) {
    state.item = value;
  },
  CUSTOMERS__REFRESH_LIST(state) {
    state.refreshList = !state.refreshList;
  },
  CUSTOMERS__REFRESH_GROUPS_LIST(state) {
    state.groups.refreshList = !state.groups.refreshList;
  },
  CUSTOMERS__UPDATE_GROUPS_LOADING(state, value) {
    state.groups.loading = value;
  },
  CUSTOMERS__UPDATE_GROUPS_LIST_LOADING(state, value) {
    state.groups.listLoading = value;
  },
  CUSTOMERS__UPDATE_GROUPS_LIST(state, value) {
    state.groups.items = value;
  },
  CUSTOMERS__UPDATE_GROUPS_TOTAL(state, value) {
    state.groups.total = value;
  },
  CUSTOMERS__UPDATE_GROUPS_PAGE_NO(state, value) {
    state.groups.pageNo = value;
  },
  CUSTOMERS__UPDATE_GROUPS_PAGE_SIZE(state, value) {
    state.groups.pageSize = value;
  },
};
